<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết danh mục công việc</h1>
      <div style="float: right">
        <button
          @click="$router.push({ path: `/cat-calendar-afs` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3">
          <div class="form-detail">
            <h1>Thông tin danh mục công việc</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nhóm công việc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ groupName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên công việc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.taskName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã công việc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.taskCode }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.note">
              <label for="" class="col-sm-4 col-form-label"
                >Mô tả<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.note }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Cấp độ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.level }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian đánh giá điểm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.reviewTime }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Điều kiện đánh giá<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.condition }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Điểm đánh giá<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.point }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        id: this.$route.params.id,
        detail: {},
        idGr: '',
        groupName: '',
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          const data = await CalendarAfsService.detailCatCalendar({
            id: this.id,
          })
          if (data.success) {
            this.detail = data.data
            this.idGr = data.data.wkGroupId
            this.getNameGroup()
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getNameGroup() {
        try {
          const res = await CalendarAfsService.detailGroupCalendar({
            id: this.idGr,
          })
          if (res.success) {
            this.groupName = res.data.groupName
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
